import React from 'react';
import { Check } from 'lucide-react';
import { pricingTiers } from '../data/mock';

const Pricing = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="section-padding bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="section-heading-custom mb-4">Pricing</h2>
          <p className="body-large-custom max-w-2xl mx-auto opacity-60">
            Custom-made artwork below ₹799. Choose from our pricing tiers or request a custom quote
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto">
          {pricingTiers.map((tier) => (
            <div
              key={tier.id}
              className={`pricing-card ${tier.popular ? 'popular' : ''}`}
              style={{ 
                background: tier.color,
                border: tier.popular ? '3px solid #151515' : 'none'
              }}
            >
              {tier.popular && (
                <div className="popular-badge">
                  Most Popular
                </div>
              )}
              
              <div className="p-6 lg:p-8 space-y-6">
                <div>
                  <h3 className="card-heading-custom mb-2 text-white">{tier.name}</h3>
                  <p className="text-3xl font-semibold text-white">{tier.price}</p>
                </div>

                <ul className="space-y-3">
                  {tier.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-3 text-white">
                      <Check size={20} className="flex-shrink-0 mt-0.5 text-white" />
                      <span className="body-medium-custom text-white">{feature}</span>
                    </li>
                  ))}
                </ul>

                <button 
                  onClick={scrollToContact}
                  className={tier.popular ? 'cta-button w-full' : 'cta-button-outline-white w-full'}
                >
                  Order Now
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Custom Order CTA */}
        <div className="mt-16 text-center bg-gray-50 rounded-lg p-8 lg:p-12">
          <h3 className="section-heading-custom mb-4">Need Something Custom?</h3>
          <p className="body-large-custom max-w-2xl mx-auto mb-6 opacity-60">
            Have a specific idea in mind? Let's bring your vision to life with a custom artwork tailored just for you.
          </p>
          <button onClick={scrollToContact} className="cta-button large">
            Request Custom Quote
          </button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
